<h1 *ngIf="isDesktop"
  class="text-left">{{ header | translate }}</h1>
<h3 [class.text-center]="!isDesktop"
  *ngIf="description">{{ description | translate }}</h3>